// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';

/** @ngInject */
export function Controller(
    $http,
    $scope,
    $state,
    $timeout,
    Alert,
    UserProvisioningService,
) {
    this.$onInit = () => {
    $scope.selectedCategories = [];
    $scope.msCategories = [];
    $scope.disableSaveLicenses=true;
    $scope.queryLicenses="";

    const companyId = $state.params.companyId;
    const appId = $state.params.appId;
    $scope.configurationId = null;
    $scope.ongoingProcess = false;
    $scope.ongoingProcessType = null;

    $scope.application = this.application;
    $scope.userProvisioningEnabled = false;

        loadConfigurationOverviewDTO(this.configurationOverviewDTO);

        $scope.init = () => {
            UserProvisioningService.provisioningConfiguration
                .get({companyId, appId}).$promise
                .then(loadConfigurationOverviewDTO)
        };

        function loadConfigurationOverviewDTO(data) {
            $scope.provisioningConfiguration = data.o365Configuration;
            $scope.configurationId = data.o365Configuration.id;
            $scope.ongoingProcess = (data.provisioningType!=null);
            $scope.ongoingProcessType = data.provisioningType;
            $scope.importReport = data.o365ImportReport;
            $scope.exportReport = data.o365ExportReport;
            if ($scope.configurationId != null) {
                $scope.userProvisioningEnabled = true;
            }
            $scope.sendVerificationEmails = data.o365Configuration.sendVerficationEmail;
            setNewLicenses(data.licenses);
        }

    $scope.cancelDisable = function() {
        $scope.userProvisioningEnabled = true;
    }
    $scope.checkDisableProvisioningModal = function(newValue) {
        if (!newValue && $scope.configurationId != null) {
            $('#disableProvisioningModal').modal('show');
        }
    }
    $scope.refreshLicenses = function() {
        UserProvisioningService.userProvisioningLicenses.query({
            companyId : companyId,
            appId : appId
        }).$promise.then(function(data) {
            setNewLicenses(data);
            Alert('success', 'provisioning.refresh_licenses_success_text');
        });
    }
    $scope.changeSelection = function(member) {
        $scope.disableSaveLicenses=false;
        var index=$scope.selectedCategories.indexOf(member);
        if( index==-1){
            $scope.selectedCategories.push(member);
        } else {
            $scope.selectedCategories.splice(index, 1);
        }
        
    }

    $scope.saveConfiguration = function() {
        UserProvisioningService.provisioningConfiguration.save({
            companyId : companyId,
            appId : appId
        }, $scope.provisioningConfiguration).$promise.then(function(data) {
            $scope.provisioningConfiguration = data.o365Configuration;
            $scope.configurationId = data.o365Configuration.id;
            $scope.ongoingProcess = (data.provisioningType!=null);
            $scope.ongoingProcessType = data.provisioningType;
            $scope.importReport = data.o365ImportReport;
            $scope.exportReport = data.o365ExportReport;

            Alert('success', 'provisioning.user_settings.save_success');
        });

    }

    $scope.saveLicenses = function() {

        var licenses = [];
        if ($scope.selectedCategories.length > 0) {
            licenses = $scope.selectedCategories;
        }
        UserProvisioningService.userProvisioningLicenses.save({
            companyId : companyId,
            appId : appId
        }, licenses).$promise.then(function(data) {
            setNewLicenses(data);
            Alert('success', 'provisioning.license.save_success');
        }, function(error) {
            $scope.disableSaveLicenses=true;
            $scope.selectedCategories = [];
            angular.forEach($scope.msCategories, function(value, index) {
                if (value.isSelected) {
                    $scope.selectedCategories.push(value.skuPartNumber);
                }
            });
        });
    }

    $scope.deleteConfiguration = function() {

        UserProvisioningService.userProvisioningAction.save({
            companyId : companyId,
            appId : appId
        }, $scope.provisioningConfiguration).$promise.then(function(data) {
            $scope.provisioningConfiguration = data;
            $scope.configurationId = null;
            $scope.importReport = null;
            $scope.exportReport = null;
            $('#disableProvisioningModal').modal('hide');
            Alert('success', 'provisioning.disable_provisioning_success');
        });

    }

    $scope.testApiConnection = function() {
        UserProvisioningService.userProvisioningTest.testConnection({
            companyId : companyId,
            appId : appId
        }, $scope.provisioningConfiguration).$promise.then(function(data) {
            setNewLicenses(data);
            Alert('success', 'provisioning.test_connection_success');
        }, function(error) {

            if (error.data.serviceErrorCode = 'ERR_103203') {
                Alert('info', error.data.message);
            }
        });
    }
    
    function setNewLicenses(data) {
        $scope.disableSaveLicenses=true;
        $scope.msCategories = [];
        $scope.selectedCategories = [];
        angular.forEach(data, function(value, index) {
            $scope.msCategories.push(value.skuPartNumber);
            if (value.isSelected) {
                $scope.selectedCategories.push(value.skuPartNumber);
            }
            
        });
    }

    $scope.changeSendVerificationEmailFlag = function() {
        UserProvisioningService.provisioningConfiguration.updateVerificationEmailFlag({
            companyId : companyId,
            appId : appId
        }, !$scope.sendVerificationEmails).$promise.then(function() {
            $scope.sendVerificationEmails = !$scope.sendVerificationEmails;
            if ($scope.sendVerificationEmails) {
                Alert('success', 'provisioning.import_users.send_verification_email_enabled');
            } else {
                Alert('success', 'provisioning.import_users.send_verification_email_disabled');
            }
        });
    }

    $scope.importUsersFromO365 = function() {
        UserProvisioningService.userProvisioningImport.save({
            companyId : companyId,
            appId : appId
        }, {}).$promise.then(function(data) {
            $scope.ongoingProcess = true;
            $scope.ongoingProcessType = 'IMPORT';
        }, function(error) {
            if (error.data.serviceErrorCode == 'ERR_103204') {
                $scope.ongoingProcess = true;
                scope.ongoingProcessType = 'IMPORT';
            }
        });
    }

    $scope.exportUsersToO365 = function() {
        UserProvisioningService.userProvisioningExport.save({
            companyId : companyId,
            appId : appId
        }, {}).$promise.then(function(data) {
            $scope.ongoingProcess = true;
            $scope.ongoingProcessType = 'EXPORT';
        }, function(error) {
            if (error.data.serviceErrorCode == 'ERR_103204') {
                $scope.ongoingProcess = true;
                $scope.ongoingProcessType = 'EXPORT';
            }
        });
    }

    $scope.exportUsersToO365Now = function() {
        $scope.exportUsersToO365();
        $('#enableAutoModal').modal('hide');
    }

    $scope.changeAllouAutoProvisioning = function(newValue) {

        UserProvisioningService.provisioningConfiguration.updateAutoProvisioning({
            companyId : companyId,
            appId : appId
        }, newValue).$promise.then(function(data) {
            $scope.provisioningConfiguration = data.o365Configuration;
            $scope.configurationId = data.o365Configuration.id;
            $scope.ongoingProcess = (data.provisioningType!=null);
            $scope.ongoingProcessType = data.provisioningType;
            $scope.importReport = data.o365ImportReport;
            $scope.exportReport = data.o365ExportReport;
            if (newValue) {
                $('#enableAutoModal').modal('show');
            }
        });
    }

    $scope.displayExportSpinner = false;
    $scope.generateReportForO365 = function(type, filter) {
        $scope.displayExportSpinner = type;

        var dateVar = new Date();
        var timeZone = dateVar.getTimezoneOffset() / 60 * (-1);

        var url = "app/rest/admin/company/" + companyId + "/application/" + appId
                + "/manageapp/userprovisioning/report";

        $http.get(url, {
            params : {
                filter : filter,
                type : type,
                timeZone : timeZone
            },
            responseType : 'arraybuffer'
        }).then((response) => {
            $timeout(function() {
                var file = new Blob([response.data], {
                    type : 'application/pdf'
                });
                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'Office365_' + type + '_Report_' + dateVar.toLocaleDateString() + '.pdf';
                document.body.appendChild(a);
                a.click();
                $scope.displayExportSpinner = false;
            });
        }).catch((response) => {
            var decodedString = String.fromCharCode.apply(null, new Uint8Array(response.data));
            var obj = JSON.parse(decodedString);                    
            $scope.displayExportSpinner = false;
            Alert('danger', obj.message);
        });
    }
    };
}




// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/o365-provisioning/o365-provisioning.controller.js